import { getWindowDimensions } from "../dimensions";
export const createDimensionQueryHelper =
  (queryFunction) => (value, styles) => {
    const isMatched = queryFunction({
      value,
      dimensions: getWindowDimensions(),
    });
    if (isMatched) {
      return styles;
    }
    return null;
  };
export const maxHeight = createDimensionQueryHelper(
  ({ value, dimensions }) => value >= dimensions.height
);
export const maxWidth = createDimensionQueryHelper(
  ({ value, dimensions }) => value >= dimensions.width
);
export const minHeight = createDimensionQueryHelper(
  ({ value, dimensions }) => value <= dimensions.height
);
export const minWidth = createDimensionQueryHelper(
  ({ value, dimensions }) => value <= dimensions.width
);
export const minAspectRatio = createDimensionQueryHelper(
  ({ value, dimensions: { width, height } }) => value <= width / height
);
export const maxAspectRatio = createDimensionQueryHelper(
  ({ value, dimensions: { width, height } }) => value >= width / height
);
export const aspectRatio = createDimensionQueryHelper(
  ({ value, dimensions: { width, height } }) => value === width / height
);
